const pluralUnit = (one: string, few: string, many: string) => ({
  few: `{{count}} ${few}`,
  many: `{{count}} ${many}`,
  one: `{{count}} ${one}`,
});

export const hrTranslation = {
  absenceCodes: {
    CARE_LEAVE: 'UOP',
    CHILD_CARE: 'OD',
    FORCE_MAJEURE: 'SW',
    OCCASIONAL: 'UO',
    ON_DEMAND: 'UŻ',
    SICK: 'L4',
    UNPAID: 'UB',
    VACATION: 'UW',
  },
  absenceTypes: {
    CARE_LEAVE: 'Urlop opiekuńczy',
    CHILD_CARE: 'Opieka nad dzieckiem',
    FORCE_MAJEURE: 'Siła wyższa',
    OCCASIONAL: 'Urlop okolicznościowy',
    ON_DEMAND: 'Urlop na żądanie',
    SICK: 'Zwolnienie lekarskie',
    UNPAID: 'Urlop bezpłatny',
    VACATION: 'Urlop wypoczynkowy',
  },
  attention: {
    kinds: {
      CARRIED_OVER_DUE: '{{days}} zaległego urlopu do wykorzystania do {{date}}',
      CARRIED_OVER_OVERDUE:
        '{{days}} zaległego urlopu po terminie {{date}} — trzeba go udzielić jak najszybciej',
      CONTRACT_ENDING: 'Umowa kończy się {{date}}',
      DOCUMENT_EXPIRED: '{{document}} — termin minął {{date}}',
      DOCUMENT_EXPIRING: '{{document}} — ważne do {{date}}',
      DOCUMENT_MISSING: 'Brak dokumentu: {{document}}',
      PROBATION_ENDING: 'Okres próbny kończy się {{date}} — zdecyduj o dalszej umowie',
      SATURDAY_HOLIDAY: 'Wyznacz pracownikom inny dzień wolny w okresie rozliczeniowym',
    },
    saturdayTitle: '{{holiday}} ({{date}}) wypada w sobotę',
    severity: {
      CRITICAL: 'Pilne',
      INFO: 'Informacja',
      WARNING: 'Wkrótce',
    },
    showAll: 'Pokaż wszystkie ({{count}})',
    showLess: 'Zwiń',
  },
  availability: {
    blockedPerson:
      'Brak ważnego szkolenia BHP lub orzeczenia sanitarno-epidemiologicznego — nie można przydzielić do realizacji',
    cell: {
      ASSIGNED: 'Przydział',
      AVAILABLE: 'Tak',
      NONE: '?',
      UNAVAILABLE: 'Nie',
    },
    cellHints: {
      assign: 'Kliknij, aby przydzielić do realizacji',
      ASSIGNED: 'Przydzielony do realizacji',
      assignedLocked: 'Masz przydział — zmianę uzgodnij z kierowniczką obsługi',
      AVAILABLE: 'Zgłoszona dostępność',
      blocked: 'Nie można przydzielić — brak ważnych dokumentów',
      cycle: 'Kliknij, aby zmienić: tak → nie → bez zgłoszenia',
      NONE: 'Czeka na zgłoszenie dostępności',
      unassign: 'Kliknij, aby cofnąć przydział',
      UNAVAILABLE: 'Zgłoszony brak dostępności',
    },
    complete: 'Komplet',
    contractorDone: 'Wszystkie terminy zgłoszone — dziękujemy!',
    contractorHint:
      'Kliknij termin, aby zgłosić, czy możesz pracować. Przydziały potwierdza kierowniczka obsługi — zobaczysz je tutaj i dostaniesz SMS.',
    contractorTitle: 'Bez zgłoszenia: {{terms}}',
    coverage: 'Przydz. {{assigned}}/{{needed}}',
    eventTooltip: '{{name}} — {{guests}} gości, potrzeba obsługi: {{staff}}',
    managerHint:
      'Kelnerzy i barmani na zlecenie zgłaszają, w które dni mogą pracować. Kliknij dostępną osobę, aby przydzielić ją do realizacji. Osoby bez ważnego BHP lub orzeczenia sanepid są zablokowane.',
    missing: 'Do obsadzenia',
    missingCount: 'Brakuje {{missing}} (dost. {{available}})',
    person: 'Osoba',
    poolHint:
      'Widoczne są tylko terminy z realizacjami w najbliższych 6 tygodniach. Zapotrzebowanie liczymy z liczby gości (wesele: 1 osoba na 35 gości, pozostałe: 1 na 50).',
    remind: 'Przypomnij o zgłoszeniu ({{people}})',
    reminderSent: 'Wysłano przypomnienie (SMS i e-mail) — {{people}}',
  },
  balance: {
    limitUsage: '{{used}} z {{limit}} dni',
    meter: {
      free: 'Wolne',
      pending: 'Czeka na decyzję',
      used: 'Wykorzystane',
    },
    remainingOf: 'dni do wykorzystania z {{total}}',
  },
  calendar: {
    absenceTooltip: '{{name}}: {{label}} · {{range}} · {{status}}',
    atRiskTooltip: '— po zatwierdzeniu oczekujących wniosków zostanie {{present}}.',
    employee: 'Pracownik',
    events: 'Realizacje',
    eventTooltip: '{{name}} — {{guests}} gości',
    export: 'Eksport do płac (CSV)',
    hintEmployee:
      'Kliknij wolny dzień w swoim wierszu, aby złożyć wniosek. U kolegów widzisz tylko, że są nieobecni — bez powodu nieobecności.',
    hintManager:
      'Kliknij wolny dzień pracownika, aby złożyć wniosek w jego imieniu, albo nieobecność, aby zobaczyć szczegóły. Wiersz „Obecni” jest czerwony, gdy obsada spada poniżej minimum, a pomarańczowy, gdy spadnie po zatwierdzeniu oczekujących wniosków.',
    hintOwner:
      'Podgląd całej firmy. Kliknij nieobecność, aby zobaczyć szczegóły — zmiany wprowadzają przełożeni i kadry.',
    legendHidden: 'Nieobecność (bez powodu)',
    legendPending: 'Wniosek czeka na decyzję',
    minStaffing: 'minimalna obsada: {{count}}',
    next: 'Następny miesiąc',
    present: 'Obecni',
    presentTooltip: 'Obecnych {{present}} z {{total}} (minimum {{minimum}})',
    previous: 'Poprzedni miesiąc',
    today: 'Dziś',
  },
  compliance: {
    complete: 'Komplet dokumentów',
    completeHint: 'z {{people}}',
    employee: 'Pracownik',
    empty: 'Wszyscy mają aktualne badania i szkolenia.',
    everyone: 'Wszyscy',
    expired: 'Po terminie',
    expiredHint: 'osoba nie powinna pracować do odnowienia',
    expiring: 'Wygasają w 30 dni',
    expiringHint: 'czas umówić termin',
    filter: 'Pokaż',
    missing: 'Braki w kartotece',
    missingHint: 'dokument nie został dostarczony',
    onlyAction: 'Wymagają działania',
    remindAll: 'Przypomnij wszystkim ({{people}})',
    reminderSent: 'Wysłano przypomnienie (SMS i e-mail) — {{people}}',
    remindOne: 'Wyślij przypomnienie',
  },
  contracts: {
    EMPLOYMENT: 'Umowa o pracę',
    MANDATE: 'Umowa zlecenie',
    PROBATION: 'Okres próbny',
  },
  departments: {
    KITCHEN: 'Kuchnia',
    LOGISTICS: 'Logistyka i magazyn',
    OFFICE: 'Biuro',
    SERVICE: 'Obsługa eventów',
  },
  description:
    'Wnioski urlopowe i ich zatwierdzanie, kalendarz nieobecności, dyspozycyjność obsługi na realizacje oraz pilnowanie badań, BHP i orzeczeń sanepid.',
  details: {
    approve: 'Zatwierdź',
    cancelRequest: 'Anuluj wniosek',
    close: 'Zamknij',
    comment: 'Komentarz',
    decisionComment: 'Komentarz do decyzji',
    decisionCommentPlaceholder: 'Wymagany przy odrzuceniu, np. propozycja innego terminu',
    history: 'Historia wniosku',
    impact: 'Szczegóły nieobecności',
    impactPending: 'Na co zwrócić uwagę',
    noComment: 'Brak',
    range: 'Termin',
    reject: 'Odrzuć',
    rejectHint: 'Wpisz komentarz, aby odrzucić wniosek',
    substitute: 'Zastępstwo',
    toast: {
      approved: 'Wniosek zatwierdzony — pracownik dostał powiadomienie',
      cancelled: 'Wniosek anulowany',
      rejected: 'Wniosek odrzucony — pracownik dostał powiadomienie z komentarzem',
    },
    waitingFor: 'Czeka na decyzję',
  },
  documents: {
    DRIVER: 'Kwalifikacja kierowcy',
    HACCP: 'Szkolenie HACCP',
    MEDICAL: 'Badania okresowe',
    SAFETY: 'Szkolenie BHP',
    SANITARY: 'Orzeczenie sanitarno-epidemiologiczne',
  },
  documentsList: {
    expired: 'Wygasło',
    expiring: 'Wkrótce wygasa',
    indefinite: 'Bezterminowo',
    missing: 'Brak w kartotece',
    ok: 'Ważne',
    stateMissing: 'Brak',
    validUntil: 'Ważne do {{date}}',
  },
  documentsShort: {
    DRIVER: 'Kierowca',
    HACCP: 'HACCP',
    MEDICAL: 'Badania',
    SAFETY: 'BHP',
    SANITARY: 'Sanepid',
  },
  documentState: {
    EXPIREDDate: 'po terminie, {{date}}',
    EXPIRINGDate: 'do {{date}}',
    indefinite: 'bezterminowo',
    MISSING: 'brak',
    notRequired: 'nie dotyczy',
    OKDate: 'do {{date}}',
  },
  employeeCard: {
    assignments: 'Najbliższe przydziały',
    close: 'Zamknij',
    contractEnds: 'Umowa do',
    documents: 'Badania, szkolenia i uprawnienia',
    email: 'E-mail',
    fte: 'Wymiar etatu',
    fullTime: 'Pełny etat',
    hiredAt: 'Data zatrudnienia',
    history: 'Historia nieobecności',
    leave: 'Urlop {{year}}',
    limits: 'Limity w tym roku',
    manager: 'Przełożony',
    mandateInfo:
      'Umowa zlecenie — bez urlopu wypoczynkowego. Osoba zgłasza dyspozycyjność na realizacje, a godziny rozliczamy po każdym evencie.',
    newRequest: 'Złóż wniosek w imieniu',
    noAssignments: 'Brak przydziałów w najbliższych tygodniach.',
    noHistory: 'Brak wniosków w tym roku.',
    perHour: 'brutto / h',
    perMonth: 'brutto / mies.',
    phone: 'Telefon',
    registerSick: 'Zarejestruj L4',
    salary: 'Wynagrodzenie',
    tabs: {
      profile: 'Profil',
      timeline: 'Oś czasu ({{count}})',
    },
  },
  employees: {
    atWork: 'W pracy',
    columns: {
      carried: 'Zaległy',
      contract: 'Umowa',
      department: 'Dział',
      documents: 'Badania i szkolenia',
      employee: 'Pracownik',
      leave: 'Urlop: zostało / przysługuje',
      salary: 'Wynagrodzenie',
      today: 'Dziś',
    },
    contractWithFte: '{{contract}}, {{fte}}',
    documentsOk: 'Komplet',
    halfTime: '1/2 etatu',
    leaveValue: '{{remaining}} / {{total}} dni',
    notApplicable: 'nie dotyczy',
    onEvent: 'Na realizacji',
    search: 'Szukaj po nazwisku lub stanowisku',
    until: 'do {{date}}',
  },
  hero: {
    carriedDue: 'W tym {{days}} zaległego urlopu — wykorzystaj go do 30 września.',
    carriedOverdue:
      '{{days}} zaległego urlopu po terminie 30 września — ustal termin z przełożonym.',
    childCare: 'Opieka nad dzieckiem',
    details: 'Szczegóły wniosku',
    inDays: 'Za {{days}}',
    newRequest: 'Złóż wniosek urlopowy',
    nextEmpty:
      'Nie masz zaplanowanych nieobecności. Kliknij wolny dzień w kalendarzu poniżej, żeby zaplanować urlop.',
    nextTitle: 'Najbliższa nieobecność',
    onDemand: 'Urlop na żądanie',
    ongoing: 'Trwa teraz',
    remaining: 'dni urlopu do wykorzystania',
    returnOn: 'Wracasz w {{date}}',
    returnShort: 'powrót {{date}}',
    substitute: 'Zastępuje Cię {{name}}',
    title: 'Twój urlop w {{year}}',
    total: 'Przysługuje Ci {{total}} w tym roku',
    totalWithCarried: 'Przysługuje Ci {{total}}: {{entitlement}} wymiaru i {{carried}} zaległego',
  },
  hiddenAbsence: 'Nieobecność',
  historyActions: {
    APPROVED: 'Zatwierdzony',
    CANCELLED: 'Anulowany',
    REGISTERED: 'Zarejestrowane z e-ZLA',
    REJECTED: 'Odrzucony',
    SUBMITTED: 'Złożony',
    SUBMITTED_ON_BEHALF: 'Złożony w imieniu pracownika',
  },
  holidays: {
    allSaints: 'Wszystkich Świętych',
    assumption: 'Wniebowzięcie NMP',
    boxingDay: 'Drugi dzień Bożego Narodzenia',
    christmasDay: 'Boże Narodzenie',
    christmasEve: 'Wigilia',
    constitutionDay: 'Święto Konstytucji 3 Maja',
    corpusChristi: 'Boże Ciało',
    easterMonday: 'Poniedziałek Wielkanocny',
    easterSunday: 'Wielkanoc',
    epiphany: 'Trzech Króli',
    independenceDay: 'Święto Niepodległości',
    labourDay: 'Święto Pracy',
    newYear: 'Nowy Rok',
    pentecost: 'Zielone Świątki',
  },
  impact: {
    balance: 'Saldo urlopu: {{before}} → {{after}} dni',
    balanceError: 'Za mało dni urlopu. Wybierz krótszy termin albo inny rodzaj nieobecności.',
    clear: 'Brak konfliktów z zespołem i obsadą.',
    empty: 'W wybranym okresie nie ma dni roboczych.',
    eventEntry: '{{date}} {{name}} ({{guests}} gości)',
    events: 'W tym czasie: {{events}}',
    holidays: 'Nie liczą się święta: {{holidays}}',
    hours: '{{hours}} h',
    limit: 'Limit roczny: wykorzystane {{before}} z {{limit}}, po wniosku {{after}} z {{limit}}',
    moreEvents: 'i {{count}} więcej',
    overlap: 'Nakłada się na inny wniosek: {{type}}, {{range}}',
    pickDates: 'Wybierz termin, aby zobaczyć saldo i konflikty.',
    substitute: 'Osoba zastępująca też jest wtedy nieobecna.',
    team: 'W tym czasie nieobecni w dziale:',
    teamEntry: '{{name}} ({{reason}}, {{range}}, {{status}})',
    teamEntryHidden: '{{name}} ({{range}})',
    understaffed: 'Obsada działu {{department}} spadnie poniżej minimum:',
    understaffedDay: '{{date}} ({{present}}/{{total}})',
  },
  myDocuments: {
    about: {
      DRIVER:
        'Świadectwo kwalifikacji zawodowej kierowcy. Odnawiane co 5 lat po szkoleniu okresowym.',
      HACCP: 'Zasady higieny i bezpieczeństwa żywności. Szkolenie przypominające co rok.',
      MEDICAL: 'Badania okresowe z medycyny pracy. Skierowanie wystawiają kadry.',
      SAFETY: 'Szkolenie okresowe BHP. Kadry zapisują na najbliższy termin.',
      SANITARY:
        'Orzeczenie do celów sanitarno-epidemiologicznych. Wymagane przy pracy z żywnością.',
    },
    action: {
      DRIVER: 'Kadry zapiszą Cię na szkolenie okresowe kierowców — termin dostaniesz SMS-em.',
      HACCP: 'Kadry zapiszą Cię na najbliższe szkolenie HACCP — termin dostaniesz SMS-em.',
      MEDICAL: 'Kadry wystawią skierowanie na badania okresowe — dostaniesz je e-mailem.',
      SAFETY: 'Kadry zapiszą Cię na szkolenie BHP — termin dostaniesz SMS-em.',
      SANITARY: 'Przynieś orzeczenie do kadr. Bez niego nie możesz pracować przy żywności.',
    },
    intro:
      'Badania, szkolenia i orzeczenia wymagane na Twoim stanowisku. Przypomnimy, zanim stracą ważność.',
  },
  overview: {
    absentTodayTitle: 'Nieobecni dziś',
    approve: 'Zatwierdź',
    approvedToast: 'Wniosek zatwierdzony',
    attentionTitle: 'Wymaga uwagi',
    contractor: {
      assigned: 'Przydziały',
      assignedHint: 'potwierdzone realizacje',
      available: 'Zgłoszona dostępność',
      eventLine: '{{name}} · {{guests}} gości',
      fill: 'Uzupełnij dyspozycyjność',
      info: 'Pracujesz na umowie zlecenie, więc nie składasz wniosków urlopowych. Zgłaszasz, w które dni możesz pracować przy realizacjach.',
      nextEvents: 'Moje najbliższe realizacje',
      noEvents: 'Nie masz jeszcze przydziałów. Zgłoś dostępność, a koordynator Cię przydzieli.',
      subtitle: 'Dyspozycyjność na najbliższe {{weeks}} tygodni',
      undeclared: 'Terminy bez zgłoszenia',
      undeclaredHint: 'kliknij, aby uzupełnić',
    },
    contractsHint: 'Wszyscy pracownicy i współpracownicy',
    contractsTitle: 'Struktura zatrudnienia',
    documentsHint: 'Przypomnimy, zanim stracą ważność',
    employee: {
      carriedTitle: 'Zaległy urlop',
      colleagues: 'Nieobecni w dziale — najbliższe {{count}} dni',
      colleaguesHint: 'Widzisz, kto będzie nieobecny, ale bez powodu nieobecności',
      documentsLink: 'Moje badania',
      limits: 'Limity w {{year}}',
      limitsHint: 'Urlop na żądanie liczy się też do puli urlopu wypoczynkowego',
      myRequests: 'Moje wnioski',
      noColleagues: 'Nikt z działu nie planuje nieobecności.',
      noReminders: 'Twoje badania i szkolenia są aktualne.',
      noRequests: 'Nie masz jeszcze wniosków.',
      reminderKinds: {
        CARRIED_OVER_DUE: 'Masz {{days}} zaległego urlopu — wykorzystaj go do {{date}}.',
        CARRIED_OVER_OVERDUE:
          'Masz {{days}} zaległego urlopu po terminie {{date}} — ustal termin z przełożonym.',
        CONTRACT_ENDING: 'Umowa kończy się {{date}}.',
        DOCUMENT_EXPIRED: 'Termin minął {{date}}. Kadry wyślą Ci skierowanie.',
        DOCUMENT_EXPIRING: 'Ważne do {{date}}. Kadry umówią termin odnowienia.',
        DOCUMENT_MISSING: 'Brakuje w kartotece. Przynieś dokument do kadr.',
        PROBATION_ENDING: 'Okres próbny kończy się {{date}}.',
        SATURDAY_HOLIDAY: '',
      },
      reminders: 'Twoje terminy',
    },
    everyoneAtWork: 'Wszyscy są dziś w pracy.',
    followUpsHint: 'Rozmowy i notatki z datą powrotu do tematu w ciągu 30 dni',
    followUpsTitle: 'Do omówienia',
    greeting: 'Dzień dobry, {{name}}',
    hr: {
      attentionHint: 'Badania, BHP, sanepid, zaległe urlopy i umowy w całej firmie',
      pendingHint: 'Wszystkie wnioski w firmie — decyzję podejmuje przełożony pracownika',
      subtitle: 'Kadry całej firmy — {{people}}',
    },
    manager: {
      attentionHint: 'Badania, szkolenia i zaległe urlopy Twojego zespołu',
      newOnBehalf: 'Złóż wniosek za pracownika',
      pendingHint: 'Wnioski Twojego zespołu — sprawdź konflikty przed decyzją',
      subtitle: 'Twój zespół — {{people}}',
    },
    myDocuments: 'Moje badania i szkolenia',
    noAttention: 'Wszystkie dokumenty są aktualne.',
    noFollowUps: 'Nie ma tematów do podjęcia w najbliższym miesiącu.',
    noPending: 'Brak wniosków do zatwierdzenia.',
    noUpcoming: 'Brak zaplanowanych nieobecności.',
    pendingTitle: 'Wnioski do zatwierdzenia',
    presenceTitleCompany: 'Dziś w firmie',
    presenceTitleTeam: 'Dziś w Twoim dziale',
    showAll: 'Wszystkie',
    tiles: {
      absentToday: 'Nieobecni dziś',
      absentTodayHint: 'w zespole: {{people}}',
      absentTodayHintCompany: 'na etacie w firmie: {{people}}',
      carried: 'Zaległe urlopy',
      carriedHint: 'osoby z niewykorzystanym urlopem zaległym',
      documents: 'Badania i szkolenia',
      documentsHint: 'do odnowienia lub uzupełnienia',
      pending: 'Do zatwierdzenia',
      pendingHint: 'wnioski czekające na decyzję',
      upcoming: 'Nieobecności wkrótce',
      upcomingHint: 'zaczynają się w ciągu {{count}} dni',
    },
    until: 'do {{date}}',
    upcomingTitle: 'Zaczynają się w ciągu {{count}} dni',
    waitingFor: 'czeka na: {{name}}',
    warnings: {
      events: 'w tym czasie {{events}}',
      team: 'równolegle nieobecni: {{people}}',
      understaffed: 'obsada poniżej minimum',
    },
  },
  owner: {
    bannerHint:
      'Widzisz całą firmę, wynagrodzenia i poufne notatki. Wnioski zatwierdzają przełożeni, a kartotekę prowadzą kadry. Ty dodajesz na osi czasu pracownika własne notatki i decyzje — prywatne widzisz tylko Ty.',
    bannerTitle: 'Widok właściciela',
    columns: {
      department: 'Dział',
      documents: 'Badania po terminie',
      monthAbsence: 'Nieobecności w miesiącu',
      payroll: 'Płace brutto / mies.',
      pending: 'Wnioski do decyzji',
      people: 'Osoby',
      present: 'Dziś w pracy',
      sickYear: 'L4 w roku',
      total: 'Razem',
    },
    decisions: 'Sprawy do decyzji',
    decisionsHint: 'Rozmowy o podwyżki, oceny i inne tematy z datą powrotu w ciągu 30 dni',
    departments: 'Działy',
    departmentsHint:
      'Nieobecności w dniach roboczych, L4 w dniach kalendarzowych, płace bez umów zlecenia',
    noDecisions: 'Nic nie czeka na Twoją decyzję w najbliższym miesiącu.',
    recent: 'Ostatnie wpisy w aktach',
    recentHint:
      'Rozmowy, notatki, pochwały i upomnienia ze wszystkich działów, także Twoje prywatne',
    subtitle: 'Cała firma — {{people}}',
    tiles: {
      leave: 'Urlop do wykorzystania',
      leaveHint: 'dni w całej firmie, w tym {{days}} zaległego',
      monthAbsence: 'Nieobecności — {{month}}',
      monthAbsenceHint: 'dni robocze bez L4',
      present: 'Obecni dziś',
      presentHint: 'pracownicy na etacie',
      sick: 'Dni L4 w {{year}}',
      sickHint: 'dni kalendarzowe, wszystkie działy',
    },
    urgent: 'Pilne',
    urgentHint: 'Braki i przeterminowane badania, szkolenia i orzeczenia',
  },
  presence: {
    absent: 'nieobecność',
    present: 'w pracy',
    value: '{{present}} z {{total}} w pracy, minimum {{minimum}}',
  },
  prototype: {
    badge: 'Prototyp na danych przykładowych',
    info: 'Nic nie jest zapisywane. Przełączaj strefy, żeby zobaczyć moduł oczami pracownika, przełożonego, kadr i właściciela. Po odświeżeniu strony dane wracają do stanu początkowego.',
    reset: 'Przywróć dane przykładowe',
  },
  requestDialog: {
    approveNow: 'Zatwierdź od razu (np. wniosek zgłoszony telefonicznie)',
    cancel: 'Anuluj',
    comment: 'Komentarz',
    commentPlaceholder: 'Opcjonalnie — np. powód lub ustalenia z zespołem',
    employee: 'Pracownik',
    from: 'Od',
    fromLower: 'data rozpoczęcia',
    onBehalfHint:
      'Składasz wniosek w imieniu pracownika — dostanie powiadomienie, a w historii zostanie ślad, kto złożył wniosek.',
    register: 'Zarejestruj zwolnienie',
    sickComment: 'Numer e-ZLA / uwagi',
    submit: 'Złóż wniosek',
    submitAndApprove: 'Złóż i zatwierdź',
    substitute: 'Zastępstwo',
    substitutePlaceholder: 'Kto przejmie obowiązki?',
    summary: 'Podsumowanie',
    summaryHint: 'Liczone na bieżąco: dni robocze, saldo, limity i konflikty',
    title: 'Nowy wniosek',
    titleSick: 'Rejestracja zwolnienia lekarskiego',
    to: 'Do',
    toast: {
      approved: 'Wniosek złożony i zatwierdzony',
      registered: 'Zwolnienie zarejestrowane',
      submitted: 'Wniosek złożony — przełożony dostał powiadomienie',
    },
    type: 'Rodzaj nieobecności',
  },
  requests: {
    columns: {
      attention: 'Uwagi',
      days: 'Dni',
      employee: 'Pracownik',
      range: 'Termin',
      status: 'Status',
      submitted: 'Złożony',
      type: 'Rodzaj',
    },
    empty: 'Brak wniosków dla wybranych filtrów.',
    filters: {
      all: 'Wszystkie',
      allDepartments: 'Wszystkie działy',
      allTypes: 'Wszystkie rodzaje',
      search: 'Szukaj pracownika',
      status: 'Status',
    },
    new: 'Złóż wniosek',
    newOnBehalf: 'Nowy wniosek',
    onBehalfBy: 'w imieniu — {{name}}',
    quickApprove: 'Zatwierdź',
    quickReject: 'Odrzuć z komentarzem',
    registeredBy: 'rejestracja: {{name}}',
    registerSick: 'Zarejestruj L4',
    teamAbsent: 'równolegle nieobecni: {{people}}',
    understaffed: 'Obsada poniżej minimum',
  },
  settings: {
    columns: {
      approval: 'Akceptacja przełożonego',
      code: 'Kod',
      limit: 'Limit',
      pay: 'Wynagrodzenie',
      pool: 'Z puli urlopu',
      type: 'Rodzaj',
    },
    flow: 'Ścieżka wniosku',
    flowSteps: {
      decide: {
        description:
          'Widzi saldo, konflikty w zespole, obsadę i realizacje w tym terminie. Zatwierdza albo odrzuca z komentarzem. Po 2 dniach bez decyzji dostaje przypomnienie.',
        title: 'Przełożony decyduje',
      },
      payroll: {
        description:
          'Zatwierdzone nieobecności trafiają do kalendarza i eksportu do systemu kadrowo-płacowego. L4 kadry rejestrują z e-ZLA bez akceptacji.',
        title: 'Kadry rozliczają',
      },
      submit: {
        description:
          'Pracownik składa wniosek w aplikacji albo przełożony robi to w jego imieniu (np. po telefonie) — wtedy może od razu zatwierdzić.',
        title: 'Wniosek',
      },
    },
    holidays: 'Dni wolne w {{year}}',
    limits: {
      CARE_LEAVE: '5 dni w roku',
      CHILD_CARE: '2 dni (lub 16 h) w roku',
      FORCE_MAJEURE: '2 dni (lub 16 h) w roku',
      OCCASIONAL: '1–2 dni na zdarzenie',
      ON_DEMAND: '4 dni w roku',
      SICK: '—',
      UNPAID: 'bez limitu',
      VACATION: '20 lub 26 dni',
    },
    registeredByHr: 'rejestrują kadry',
    ruleItems: {
      carriedOver:
        'Urlop zaległy trzeba wykorzystać do 30 września następnego roku — po terminie kadry dostają alert.',
      onDemand: 'Urlop na żądanie (4 dni) jest częścią puli urlopu wypoczynkowego.',
      ownerNotes:
        'Oś czasu pracownika widzą kadry, właściciel i (bez poufnych wpisów) przełożony. Prywatne notatki właściciela widzi tylko właściciel.',
      privacy:
        'Pracownik widzi tylko, że kolega jest nieobecny — powód (np. L4) widzą przełożony i kadry.',
      saturday: 'Święto w sobotę = obowiązek wyznaczenia innego dnia wolnego.',
      sick: 'Zwolnienia lekarskie liczymy w dniach kalendarzowych, pozostałe nieobecności w dniach roboczych.',
    },
    rules: 'Zasady wbudowane w moduł',
    saturdayNote: 'sobota — wyznacz dzień wolny',
    staffing: 'Minimalna obsada',
    staffingHint: 'Poniżej minimum kalendarz i wnioski pokazują ostrzeżenie',
    staffingValue: 'min. {{minimum}} z {{total}}',
    step: 'Krok {{number}}',
    sundayNote: 'niedziela',
    types: 'Rodzaje nieobecności',
    typesHint: 'Zgodnie z Kodeksem pracy — limity i zasady do potwierdzenia z kadrami',
  },
  statuses: {
    APPROVED: 'Zatwierdzony',
    CANCELLED: 'Anulowany',
    PENDING: 'Oczekuje',
    REJECTED: 'Odrzucony',
  },
  statusesPlural: {
    APPROVED: 'Zatwierdzone',
    CANCELLED: 'Anulowane',
    PENDING: 'Oczekujące',
    REJECTED: 'Odrzucone',
  },
  tabs: {
    CONTRACTOR: {
      availability: 'Dyspozycyjność',
      documents: 'Moje szkolenia',
      overview: 'Moje realizacje',
    },
    EMPLOYEE: {
      calendar: 'Kalendarz działu',
      documents: 'Moje badania i szkolenia',
      overview: 'Mój urlop',
      requests: 'Moje wnioski',
    },
    HR: {
      calendar: 'Kalendarz firmy',
      documents: 'Badania i szkolenia',
      employees: 'Kartoteka',
      overview: 'Pulpit kadr',
      requests: 'Wnioski',
      settings: 'Ustawienia',
    },
    MANAGER: {
      calendar: 'Grafik nieobecności',
      employees: 'Mój zespół',
      overview: 'Pulpit zespołu',
      requests: 'Do zatwierdzenia',
    },
    OWNER: {
      calendar: 'Kalendarz firmy',
      documents: 'Badania i szkolenia',
      employees: 'Kartoteka',
      overview: 'Pulpit właściciela',
      requests: 'Wnioski',
    },
  },
  timeline: {
    add: 'Dodaj wpis',
    added: 'Wpis dodany do osi czasu',
    author: '{{kind}}, {{name}}',
    bodyLabel: 'Treść',
    bodyPlaceholder: 'Co zostało powiedziane, co ustalono, co dalej',
    cancel: 'Anuluj',
    dateLabel: 'Data',
    dialogTitle: 'Nowy wpis — {{name}}',
    empty: 'Brak wpisów dla wybranego filtra.',
    filterLabel: 'Pokaż',
    filters: {
      ALL: 'Wszystko',
      CONTRACT: 'Umowa',
      CONVERSATION: 'Rozmowy',
      LEAVE: 'Nieobecności',
      NOTES: 'Notatki i oceny',
      SALARY: 'Wynagrodzenie',
    },
    followUp: {
      DUE_SOON: 'Wróć do tematu: {{date}}',
      LATER: 'Wróć do tematu: {{date}}',
      OVERDUE: 'Termin powrotu minął: {{date}}',
    },
    followUpLabel: 'Wróć do tematu',
    followUpShort: {
      DUE_SOON: '{{date}}',
      LATER: '{{date}}',
      OVERDUE: 'po terminie, {{date}}',
    },
    hired: 'Zatrudnienie',
    kindLabel: 'Rodzaj wpisu',
    kinds: {
      CONTRACT: 'Umowa',
      CONVERSATION: 'Rozmowa',
      NOTE: 'Notatka',
      PRAISE: 'Pochwała',
      SALARY: 'Wynagrodzenie',
      WARNING: 'Upomnienie',
    },
    salaryVisibilityHint: 'Wpisy o wynagrodzeniu widzą tylko kadry i właściciel.',
    save: 'Zapisz wpis',
    titleLabel: 'Tytuł',
    titlePlaceholders: {
      CONTRACT: 'np. Aneks do umowy',
      CONVERSATION: 'np. Prośba o podwyżkę',
      NOTE: 'np. Grafik na grudzień',
      PRAISE: 'np. Pochwała od klienta',
      SALARY: 'np. Podwyżka do 7 400 zł',
      WARNING: 'np. Spóźnienia na realizacje',
    },
    topicLabel: 'Temat rozmowy',
    topics: {
      DEVELOPMENT: 'Rozwój',
      OTHER: 'Inne',
      PERSONAL: 'Sprawy osobiste',
      RAISE: 'Podwyżka',
      REVIEW: 'Ocena okresowa',
    },
    topicTitles: {
      DEVELOPMENT: 'Rozmowa o rozwoju',
      OTHER: 'Rozmowa',
      PERSONAL: 'Sprawy osobiste',
      RAISE: 'Prośba o podwyżkę',
      REVIEW: 'Ocena okresowa',
    },
    visibility: {
      HR_ONLY: 'Kadry i właściciel',
      MANAGER: 'Przełożony i kadry',
      OWNER_ONLY: 'Tylko ja',
    },
    visibilityChip: {
      HR_ONLY: 'Tylko kadry i właściciel',
      MANAGER: 'Przełożony i kadry',
      OWNER_ONLY: 'Prywatne — widzisz tylko Ty',
    },
    visibilityHint:
      'Pracownik nie widzi swojej osi czasu. Rozmowy o pieniądzach i sprawy osobiste domyślnie zostają w kadrach.',
    visibilityHintOwner:
      '„Tylko ja” to Twoja prywatna notatka — nie zobaczą jej kadry ani przełożeni. Pracownik nie widzi swojej osi czasu.',
    visibilityLabel: 'Kto widzi wpis',
  },
  title: 'Kadry',
  typeHints: {
    CARE_LEAVE:
      'Bezpłatny, 5 dni w roku — opieka nad członkiem rodziny lub osobą z gospodarstwa domowego (art. 173¹ KP).',
    CHILD_CARE:
      '2 dni lub 16 godzin w roku na opiekę nad dzieckiem do 14 lat, płatne 100% (art. 188 KP).',
    FORCE_MAJEURE:
      '2 dni lub 16 godzin w roku z pilnych spraw rodzinnych, płatne 50% (art. 148¹ KP).',
    OCCASIONAL:
      '2 dni: ślub, narodziny dziecka, pogrzeb małżonka, dziecka lub rodzica. 1 dzień: ślub dziecka, pogrzeb rodzeństwa lub dziadków.',
    ON_DEMAND:
      'Maks. 4 dni w roku, w ramach puli urlopu wypoczynkowego. Zgłoś najpóźniej w dniu urlopu.',
    SICK: 'Rejestrują kadry na podstawie e-ZLA z PUE ZUS — bez akceptacji przełożonego.',
    UNPAID: 'Na pisemny wniosek pracownika, bez wynagrodzenia.',
    VACATION: 'Odejmowany z puli urlopu wypoczynkowego (bieżący + zaległy).',
  },
  units: {
    calendarDay: pluralUnit('dzień kalendarzowy', 'dni kalendarzowe', 'dni kalendarzowych'),
    day: pluralUnit('dzień', 'dni', 'dni'),
    event: pluralUnit('realizacja', 'realizacje', 'realizacji'),
    person: pluralUnit('osoba', 'osoby', 'osób'),
    request: pluralUnit('wniosek', 'wnioski', 'wniosków'),
    term: pluralUnit('termin', 'terminy', 'terminów'),
    workingDay: pluralUnit('dzień roboczy', 'dni robocze', 'dni roboczych'),
  },
  yearStrip: {
    hint: 'Kliknij wolny dzień, żeby złożyć wniosek, albo zaznaczony, żeby zobaczyć szczegóły.',
    holiday: 'Święto',
    pending: 'Czeka na decyzję',
    title: 'Mój rok {{year}}',
  },
  zones: {
    contractLabel: 'Pokaż strefę pracownika zatrudnionego na',
    contracts: {
      CONTRACTOR: 'Umowie zlecenie',
      EMPLOYEE: 'Umowie o pracę',
    },
    employee: {
      description: 'Mój urlop, wnioski, kalendarz działu i moje badania',
      title: 'Pracownik',
    },
    hr: {
      description: 'Kartoteka, wszystkie nieobecności, badania i szkolenia, eksport do płac',
      title: 'Kadry',
    },
    hrBadge: 'Pilne: {{count}}',
    label: 'Strefy modułu',
    manager: {
      description: 'Zatwierdzanie wniosków, grafik nieobecności i notatki o zespole',
      title: 'Przełożony',
    },
    managerBadge: 'Do decyzji: {{count}}',
    owner: {
      description:
        'Cała firma z wynagrodzeniami i poufnymi notatkami oraz Twoje prywatne notatki w kartotece.',
      title: 'Właściciel',
    },
    ownerBadge: 'Do decyzji: {{count}}',
  },
};

export type HrTranslation = typeof hrTranslation;
